import { ApiRoute, HttpMethod } from '../common/api/routes';

export interface RequestPasswordResetBody {
    username: string;
}
export interface ResetPasswordWithTokenBody {
    token: string;
    username: string;
    password: string;
}

export type GetLoginMethodResponse = {
    appFrontendUrl?: string;
    enableOidcAuth: boolean;
    isV2AppAuthEnabled: boolean;
}

export const LoginApi = {
    getLoginMethod: new ApiRoute<GetLoginMethodResponse, void, void, void>(
        HttpMethod.Get,
        path => path.literal('getLoginMethod'),
    ),
    requestResetPassword: new ApiRoute<void, void, RequestPasswordResetBody, void>(HttpMethod.Post, path =>
        path.literal('requestPasswordReset'),
    ),
    resetPasswordWithToken: new ApiRoute<void, void, ResetPasswordWithTokenBody, void>(HttpMethod.Post, path =>
        path.literal('resetPassword'),
    ),
};
